export const ASSET_TYPES = {
  giftcard: "Gift Cards",
  "prepaid-debit-card": "Prepaid Cards",
  subscription: "Subscriptions",
  donation: "Donations",
};
